import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { useStoreSelector } from 'hooks/store.ts'
import { useGetLanguage } from 'hooks/use-get-language'
import { Card, Heading, Icon, Toggle, Modal, StepList } from '@boltenergy-be/design-system'
import styles from '../GuaranteeOfOrigin.module.scss'
import Link from 'components/link/Link.tsx'
import Video from 'components/video/Video.tsx'
import { GO_INFO_URLS } from 'pages/app/guarantee-of-origin/what/constants.ts'
import { selectCurrentServiceContracts } from 'store/contact/slice.ts'
import { Region, REGIONS } from '@boltenergy-be/shared'

const GuaranteeOfOriginWhat = () => {
  // Redux
  const { electricity } = useStoreSelector(selectCurrentServiceContracts)

  // i18n
  const { t } = useTranslation(['guaranteeOfOrigin', 'common'])
  const language = useGetLanguage()
  const lowerCaseLanguage = useGetLanguage('lowercase')

  // Local state
  const [region, setRegion] = useState<Region>(electricity.deliveryPoint.region || REGIONS.flanders)
  const [videoModalOpen, setVideoModalOpen] = useState<boolean>(false)

  // Constants
  const infoUrl = typeof GO_INFO_URLS[region] === 'string' ? GO_INFO_URLS[region] : GO_INFO_URLS[region][language]

  return (
    <>
      <Card as="section" className={styles['video-card']} color="neutral">
        <figure>
          <button className={styles['play-btn']} onClick={() => setVideoModalOpen(true)}>
            <img
              src={`https://res.cloudinary.com/bolt-energie/video/upload/v1733229964/website/videos/guarantee-of-origin-${lowerCaseLanguage}.jpg`}
              alt=""
            />
            <div className={styles.icon}>
              <Icon name="play" />
            </div>
          </button>

          <figcaption>{t(($) => $.what.video.title)}</figcaption>
        </figure>
      </Card>

      <Card as="section" className={styles['go-info-card']}>
        <Heading as="h2" variant="h4">
          {t(($) => $.what.actions.title)}
        </Heading>

        <Toggle
          active={region}
          onClick={(r) => setRegion(r)}
          options={Object.values(REGIONS).map((r) => ({ label: t(($) => $.regions[r], { ns: 'common' }), value: r }))}
          className={styles.toggle}
          optionClassName={styles.option}
        />

        <StepList size="medium">
          {[1, 2, 3].map((key) => {
            const typedKey = key.toString() as '1' | '2' | '3'
            return (
              <li key={key}>
                <strong>{t(($) => $.what.actions[region].steps[typedKey].title)}</strong>
                <p>{t(($) => $.what.actions[region].steps[typedKey].description)}</p>
              </li>
            )
          })}
        </StepList>

        <Link representation="button" isFullwidth href={infoUrl} external>
          {t(($) => $.what.actions[region].button)}
        </Link>
      </Card>

      <Modal padding={false} isOpen={videoModalOpen} onRequestClose={() => setVideoModalOpen(false)}>
        <Video publicId={`website/videos/guarantee-of-origin-${lowerCaseLanguage}`} />
      </Modal>
    </>
  )
}

export default GuaranteeOfOriginWhat
